import $ from 'jquery';
import Service from './ajax/Service';


let isInitialErrorFocusRegistered = false;


function registerInitialErrorFocus() {
  if (isInitialErrorFocusRegistered) {
    return;
  }

  isInitialErrorFocusRegistered = true;

  $(document).ready(() => {
    const $formGroups = $('.form-group.has-error')
      .filter(':visible');

    if ($formGroups.length) {
      const $inputs = $($formGroups.first())
        .find('input, select')
        .filter(':visible');

      const $firstInput = $($inputs.first());

      $firstInput.focus();
    }
  });
}


class FieldValidationProvider {
  /**
   * @param {HTMLFormElement|string} formOrFormId
   */
  constructor(formOrFormId) {
    this.$form = typeof formOrFormId === 'string' ?
      $(`#${formOrFormId}`) : $(formOrFormId);

    registerInitialErrorFocus();
  }

  /**
   * @param {HTMLFormElement|string} formOrFormId
   */
  static createStandardProvider(formOrFormId) {
    const validationProvider = new FieldValidationProvider(formOrFormId);

    validationProvider.registerValidationEvent('blur', 'input, select, textarea');
    validationProvider.registerValidationEvent('click', 'input[type=radio], input[type=checkbox]');

    return validationProvider;
  }

  removeFeedback(id) {
    $(`.form-control-feedback[for='${id}']`).remove();
    $(`.tn-validation-sr-only[for='${id}']`).remove();
  }

  showLoading(id) {
    $(`div[data-control-group-for='${id}']`).addClass('has-feedback');

    this.removeFeedback(id);

    const html = `
      <span class="glyphicon glyphicon-refresh tn-glyphicon-spin form-control-feedback" for='${id}' aria-hidden="true"></span>
      <span class="sr-only tn-validation-sr-only" for='${id}'>(success)</span>
    `;

    $(`[data-tn-validate='true'][name='${id}']`)
      .after(html);
  }

  showSuccess(id) {
    $(`div[data-control-group-for='${id}']`)
      .removeClass('has-error');

    this.removeFeedback(id);

    $(`div.help-block[for='${id}']`)
    .html('')
    .show();
  }

  showFailure(id, message) {
    $(`div[data-control-group-for='${id}']`)
      .addClass('has-error')
      .addClass('has-feedback')
      .removeClass('has-success');

    this.removeFeedback(id);

    const html = `
      <span class="glyphicon glyphicon-remove form-control-feedback" for='${id}' aria-hidden="true"></span>
      <span class="sr-only tn-validation-sr-only" for='${id}'>(failed)</span>
    `;

    $(`[data-tn-validate='true'][name='${id}']`)
      .after(html);

    $(`div.help-block[for='${id}']`)
      .html(message)
      .show();
  }

  resetFieldMessages(id) {
    $(`div[data-control-group-for='${id}']`)
      .removeClass('has-success')
      .removeClass('has-feedback')
      .removeClass('has-error');

    this.removeFeedback(id);

    $(`div.help-block[for='${id}']`)
      .html('')
      .hide();
  }

  validateField(fieldName) {
    const $els = this.$form.find('[data-tn-validate="true"],input[type="hidden"]');
    const dictionary = {};

    $els.toArray().forEach((element) => {
      const $el = $(element);
      const type = $el.attr('type');
      const name = $el.attr('name');
      let value = null;

      if (type === 'radio' || type === 'checkbox') {
        const checkedValue = $(`[name='${fieldName}']:checked`).val();
        value = checkedValue;
      } else {
        value = $el.val();
      }

      dictionary[name] = value;
    });

    const fieldToValidate = {
      id: fieldName,
      value: dictionary[fieldName],
    };

    const form = {
      Data: dictionary,
      Field: {
        Id: fieldToValidate.id,
        Value: fieldToValidate.value,
      },
    };

    this.showLoading(fieldToValidate.id);

    new Service()
      .post('/api/validation', form)
        .done((result) => {
          if (result.message === null) {
            this.showSuccess(result.field.id);
          } else {
            this.showFailure(result.field.id, result.message);
          }
        })
        .fail(() => {
          // this.showFailure(form.Field.Id, 'unknown failure');
        });
  }

  registerValidationEvent(eventName, target) {
    this.$form.on(eventName, target, (event) => {
      const fieldName = event.target.name;

      this.validateField(fieldName);
    });
  }

  isValidationResponse(response) {
    if (Array.isArray(response) &&
      response.length > 0) {

      const responseObject = response[0];

      if (responseObject.hasOwnProperty('isValid') &&
        responseObject.hasOwnProperty('fieldId') &&
        responseObject.hasOwnProperty('message')) {
        return true;
      }
    }

    return false;
  }

  applyValidationResults(results) {

    results.forEach((result) => {
      if (result.isValid) {
        return;
      };

      this.showFailure(result.fieldId, result.message);
    });
  }
}


export default FieldValidationProvider;



// WEBPACK FOOTER //
// ./V7/tnew/lib/FieldValidationProvider.js